export enum SubscriptionTypes {
  Basic = 0,
  Business = 1,
  Premium = 2,
  NIS2 = 3,
  Container = 19,
  Partner = 99,
  Internal = 100,
}
